import Catalog from './Catalog'
import Events from './Events'
import Articles from './Articles'
import OnlineShowRoom from './OSRoom'
import { useContext } from 'react'
import { PageContext } from '@providers/PageContext'

const PreviewModule = ({ grcpm_preview_type, ...props }) => {
  const { page } = useContext(PageContext)

  const moduleData = { ...props }
  moduleData.pageMetaInfo = page.pageData

  return (
    <>
      <div className='preview-module'>
        {(() => {
          if (grcpm_preview_type === 'show-catalog') {
            return <Catalog {...moduleData} />
          } else if (['events-exhibitions', 'events', 'exhibitions'].indexOf(grcpm_preview_type) >= 0) {
            return <Events type={grcpm_preview_type} {...moduleData} />
          } else if (grcpm_preview_type === 'news-articles') {
            return <Articles {...moduleData} />
          } else if (grcpm_preview_type === 'online-room') {
            {/*
              // @ts-ignore */}
            return <OnlineShowRoom {...moduleData} roomPreviewtitle={props.grcpm_title} />
          }
          return null
        })()}
      </div>
    </>
  )
}

export default PreviewModule
